import { POSTAPI, generateHeader, errStatusHandler } from "../../../api-setup/api-helper";
import { SELECT_PROVIDER_POSTION_FILTER } from "../../../api-setup/api-endpoints";
import { setNewMessage } from "../../../redux/actions/setting-actions";

export const fetchNpiDataList = async (
  specialtyKeyData = null,
  groupKeyData = null,
  cookiesData,
  dispatch,
  history,
  returnRawData = false
) => {
  // Check for "Select All" and update data accordingly
  if (specialtyKeyData?.some((x) => x.id === "Select All")) specialtyKeyData = null;
  if (groupKeyData?.some((x) => x.id === "Select All")) groupKeyData = null;

  // Determine specialty filter
  const specialtyKey =
    specialtyKeyData === null
      ? "0"
      : specialtyKeyData.length === 1 && specialtyKeyData[0].id === "0"
        ? " AND ( IFNULL(b.specialty_mstr_key, 0) = 0 ) "
        : procareGetNullInFilter(
            specialtyKeyData.filter((x) => x.id !== "0"),
            "specialty_mstr_key",
            "number",
            "b"
          );

  const specialtyFilter =
    specialtyKeyData?.some((x) => x.id === "0") && specialtyKeyData.length > 1
      ? `${specialtyKey} OR ( IFNULL(b.specialty_mstr_key, 0) = 0 )`
      : specialtyKey;

  // Determine group filter
  const groupKey =
    groupKeyData === null
      ? "0"
      : groupKeyData.length === 1 && groupKeyData[0].id === "0"
        ? " AND ( IFNULL(b.org_title_key, 0) = 0 ) "
        : procareGetNullInFilter(
            groupKeyData.filter((x) => x.id !== "0"),
            "org_title_key",
            "number",
            "b"
          );

  const groupFilter =
    groupKeyData?.some((x) => x.id === "0") && groupKeyData.length > 1
      ? `${groupKey} OR ( IFNULL(b.org_title_key, 0) = 0 )`
      : groupKey;

  // Define data object value
  const dataObjValue = {
    in_user_key: cookiesData.out_user_id,
    in_filter: null,
    in_user_role_filter: "> 0",
    in_sort_number: 9,
    in_sort_order: "ASC",
    in_group_by: "a.npi",
    in_specialty_filter: specialtyFilter || "0",
    in_title_filter: groupFilter || "0",
    in_acct_encrypt_key: cookiesData.out_acct_encrypt_key,
  };

  try {
    // Fetch NPI data
    const resName = await getProvidePostionFilter(dataObjValue, dispatch, history);

    const tempArray = [
      ...resName.map((item) => ({
        text: item.npi === "" ? "(Empty Value)" : item.npi,
        id: item.npi === "" ? "" : item.npi,
      })),
    ];

    // Return both transformed data and raw data if requested
    if (returnRawData) {
      return {
        transformedData: tempArray,
        rawData: resName,
      };
    }

    return tempArray;
  } catch (error) {
    console.error("Error fetching NPI data:", error);
    if (returnRawData) {
      return {
        transformedData: [],
        rawData: [],
      };
    }
    return [];
  }
};

export const fetchPositionDataList = async (
  specialtyKeyData = null,
  groupKeyData = null,
  cookiesData,
  dispatch,
  history,
  returnRawData = false
) => {
  // Check for "Select All" and update data accordingly
  if (specialtyKeyData?.some((x) => x.id === "Select All")) specialtyKeyData = null;
  if (groupKeyData?.some((x) => x.id === "Select All")) groupKeyData = null;

  // Determine specialty filter
  const specialtyKey =
    specialtyKeyData === null
      ? "0"
      : specialtyKeyData.length === 1 && specialtyKeyData[0].id === "0"
        ? " AND ( IFNULL(b.specialty_mstr_key, 0) = 0 ) "
        : procareGetNullInFilter(
            specialtyKeyData.filter((x) => x.id !== "0"),
            "specialty_mstr_key",
            "number",
            "b"
          );

  const specialtyFilter =
    specialtyKeyData?.some((x) => x.id === "0") && specialtyKeyData.length > 1
      ? `${specialtyKey} OR ( IFNULL(b.specialty_mstr_key, 0) = 0 )`
      : specialtyKey;

  // Determine group filter
  const groupKey =
    groupKeyData === null
      ? "0"
      : groupKeyData.length === 1 && groupKeyData[0].id === "0"
        ? " AND ( IFNULL(b.org_title_key, 0) = 0 ) "
        : procareGetNullInFilter(groupKeyData, "org_title_key", "number", "b");

  // Define data object value
  const dataObjValue = {
    in_user_key: cookiesData.out_user_id,
    in_filter: null,
    in_user_role_filter: "> 0",
    in_sort_number: 12,
    in_sort_order: "ASC",
    in_group_by: "a.org_position_key",
    in_specialty_filter: specialtyFilter || "0",
    in_title_filter: groupKey || "0",
    in_acct_encrypt_key: cookiesData.out_acct_encrypt_key,
  };

  try {
    // Fetch position data
    const resName = await getProvidePostionFilter(dataObjValue, dispatch, history);

    const tempArray = [
      ...resName.map((item) => ({
        text: item.org_position_key === "" ? "(Empty Value)" : item.position_name,
        id: item.org_position_key === "" ? "" : item.org_position_key,
      })),
    ];

    // Return both transformed data and raw data if requested
    if (returnRawData) {
      return {
        transformedData: tempArray,
        rawData: resName,
      };
    }

    return tempArray;
  } catch (error) {
    console.error("Error fetching position data:", error);
    if (returnRawData) {
      return {
        transformedData: [],
        rawData: [],
      };
    }
    return [];
  }
};

// Helper function for filtering
const procareGetNullInFilter = (data, filterParamName, dataType = "string", alias = "a") => {
  if (!data || data.length === 0) return "";
  const nullKeyword = "a$is_null";
  let nullFilterStr = "";

  const idList = data.map((item) => item.id).join(",");

  if (idList.includes(nullKeyword)) {
    idList.replace(new RegExp(nullKeyword, "g"), "");
    nullFilterStr = ` AND (COALESCE(${alias}.${filterParamName}, ${
      dataType === "string" ? "''" : "0"
    }) ${dataType === "string" ? "= ''" : "= 0"})`;
  }
  return ` AND (${alias}.${filterParamName} IN (${idList}))${nullFilterStr}`;
};

// Import the getProvidePostionFilter function
const getProvidePostionFilter = (data, dispatch, history) => {
  return new Promise(function (resolve, reject) {
    POSTAPI(false, SELECT_PROVIDER_POSTION_FILTER, null, generateHeader(), data, dispatch).then((res) => {
      if (res) {
        if (res && res.data.out_parameters.out_ret_code === 0) {
          resolve(res.data.row_result);
        } else {
          dispatch(
            setNewMessage({
              message: res.data.out_parameters.out_error_msg,
              type: "Error",
              show: true,
            })
          );
          errStatusHandler(res, history, dispatch);
          resolve([]);
        }
      }
    });
  });
};

/**
 * Creates a bidirectional mapping between NPI values and Position keys
 * @param {Array} rawData - Raw API response data containing npi and org_position_key
 * @returns {Object} Object with npiToPosition and positionToNpi mappings
 */
export const createNpiPositionMapping = (rawData) => {
  const npiToPosition = new Map(); // NPI -> Position Key mapping
  const positionToNpi = new Map(); // Position Key -> NPI mapping

  if (!rawData || !Array.isArray(rawData)) {
    return { npiToPosition, positionToNpi };
  }

  rawData.forEach((item) => {
    const npi = item.npi || ""; // Use empty string for empty NPI
    const positionKey = item.org_position_key || "";

    if (positionKey) {
      // Map NPI to Position Key (handle empty NPI as empty string)
      const npiKey = npi === "" ? "" : npi;
      npiToPosition.set(npiKey, positionKey);

      // Map Position Key to NPI
      positionToNpi.set(positionKey, npiKey);
    }
  });

  return { npiToPosition, positionToNpi };
};
